import { Component, inject, input } from '@angular/core';
import { DisplayMessage } from '../../sb-model/display-message';
import { MatIcon } from '@angular/material/icon';
import { MatMenuItem } from '@angular/material/menu';
import { ReplyService } from '../../tiptap-editor/replyMessage/reply-message.service';

@Component({
  selector: 'app-sb-respond-message',
  imports: [MatIcon, MatMenuItem],
  templateUrl: './sb-respond-message.component.html'
})
/**
 * Begründung: Klasse dient nur zum Anzeigen der Nachricht im tiptap auf die geantwortet werden muss. Keine AFO wird
 * erfüllt.
 */
export class SbRespondMessageComponent {
  public message = input<DisplayMessage>();
  private readonly replyService = inject(ReplyService);

  onReplyClicked(msg: DisplayMessage | undefined): void {
    if (!msg) return;
    this.replyService.insertReplyIntoEditor(msg);
  }
}
